import script from "./StatementWo.vue?vue&type=script&setup=true&lang=js"
export * from "./StatementWo.vue?vue&type=script&setup=true&lang=js"

import "./StatementWo.vue?vue&type=style&index=0&id=738d82bb&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-738d82bb"]])

export default __exports__